import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const deliveryAreaService = {
    getDeliveryAreas,
    addDeliveryArea,
    updateDeliveryArea,
    deleteDeliveryArea
}

function getDeliveryAreas() {
    return apiClient.get('/delivery-area', {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function addDeliveryArea(deliveryArea) {
    return apiClient.post('/delivery-area', deliveryArea, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function updateDeliveryArea(deliveryArea) {
    return apiClient.patch(`/delivery-area/${deliveryArea.deliveryAreaId}`, deliveryArea, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteDeliveryArea(deliveryArea) {
    return apiClient.delete(`/delivery-area/${deliveryArea.deliveryAreaId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}
